<template>
  <div class="bigEvent workout" :class="{floating: !inplace, 'undone': workout.workout_done === false, 'done': workout.workout_done === true}"
       :style="inplace ? {} : {left: workout.position.left + 'px', top: workout.position.top + 'px'}">
    <div class="event-header">
      <span class="event-date">{{ workout.datetime.date() }} <template v-if="$mq == 'sm'">({{ workout.datetime.format('ddd')}})</template></span>
      <span class="event-name" :class="'style-' + workout.style">{{ workout.workout_type }}</span>
      <span class="event-actions">
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer" v-tooltip="'Edytuj'" @click.stop="$emit('edit-workout')">edit</v-icon>
        <v-icon dark class="click-effect" v-if="isActiveRunnerTrainer" v-tooltip="'Usuń'" @click.stop="$emit('remove-workout')">delete</v-icon>
        <v-icon dark class="click-effect ml-2" v-if="!inplace" v-tooltip="'Zamknij'" @click.stop="$emit('close')">close</v-icon>
      </span>
    </div>
    <div class="event-content">
      <div class="event-content__header">
        Zaplanowany trening
        <v-icon class="click-effect" v-if="isActiveRunnerTrainer" v-tooltip="'Edytuj trening'" @click.stop="$emit('edit-workout')">edit</v-icon>
      </div>
      <template v-for="el of workout.elements">
      <ul>
        <li v-if="el.with_warmup">
          <TextField label="Rozgrzewka">
            <i slot="prepend" v-tooltip="'Rozgrzewka'" class="fi flaticon-people-1 "></i>
            {{el.warmup | default('Standardowa rozgrzewka') }}
          </TextField>
        </li>
        <li v-if="el.distance" :class="[el.element_type.includes('OWB1') ? '' : 'style-' + workout.style]">
          <TextField label="Dystans" >
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1 "></i>
            {{el.distance }}
          </TextField>
        </li>
        <li v-if="el.distance_string" :class="[el.element_type.includes('OWB1') ? '' : 'style-' + workout.style]">
          <TextField label="Dystans">
            <i slot="prepend" v-tooltip="'Dystans'" class="fi flaticon-road-1 "></i>
            {{el.distance_string }}
          </TextField>
        </li>
        <li v-if="el.ascent">
          <TextField label="Podbieg">
            <v-icon slot="prepend" v-tooltip="'Podbieg'">trending_up</v-icon>
            {{el.ascent }}
          </TextField>
        </li>
        <li v-if="el.pulse">
          <TextField label="Tętno">
            <i slot="prepend" v-tooltip="'Tętno'" class="fi flaticon-pulse-line "></i>
            {{el.pulse }} bpm
          </TextField>
        </li>
        <li v-if="el.pace">
          <TextField label="Tempo">
            <i slot="prepend" v-tooltip="'Tempo'" class="fi flaticon-minutes "></i>
            {{el.pace }}
          </TextField>
        </li>
        <li v-if="el.strength">
          <TextField label="Siła biegowa">
            <i slot="prepend" v-tooltip="'Siła biegowa'" class="text-icon ">SB</i>
            {{el.strength }}
          </TextField>
        </li>
        <li v-if="el.repeats">
          <TextField label="Rytmy">
            <i slot="prepend" v-tooltip="'Rytmy'" class="text-icon ">R</i>
            {{el.repeats }}
          </TextField>
        </li>
        <li v-if="el.break_time">
          <TextField label="Przerwa">
            <i slot="prepend" v-tooltip="'Przerwa'" class="fi flaticon-people "></i>
            {{el.break_time }}
          </TextField>
        </li>
        <li v-if="el.descent">
          <TextField label="Zbieg">
            <v-icon slot="prepend" v-tooltip="'Zbieg'">trending_down</v-icon>
            {{el.descent }}
          </TextField>
        </li>
        <li v-if="el.trip_place">
          <TextField label="Miejsce">
            <v-icon slot="prepend" v-tooltip="'Miejsce'">place</v-icon>
            <a v-if="el.trip_link" :href="el.trip_link" target="_blank">{{el.trip_place }}</a>
            <span v-if="!el.trip_link">{{el.trip_place}}</span>
          </TextField>
        </li>
        <li v-if="el.with_cooling">
          <TextField label="Schłodzenie">
            <i slot="prepend" v-tooltip="'Schłodzenie'" class="text-icon ">C</i>
            {{ el.cooling | default('Standardowe schłodzenie')}}
          </TextField>
        </li>
        <li v-if="el.other">
          <TextField label="Inny trening">
            <v-icon slot="prepend" v-tooltip="'Inny trening'">short_text</v-icon>
            {{el.other }}
          </TextField>
        </li>
      </ul>
      <hr/>
      </template>
      <div v-if="workout.additional_info">
          <TextField label="Informacje od trenera" pre>
            <v-icon slot="prepend" v-tooltip="'Informacje od trenera'">info</v-icon>{{workout.additional_info}}
          </TextField>
      </div>
      <div class="event-results">
        <div class="event-results__header">
          Rezultat zawodnika
          <span class="ml-auto" v-if="!edit && (isActiveRunnerTrainer || isActiveRunner)" v-tooltip="workout.total_distance_done ? 'Edytuj rezultat' : 'Dodaj rezultat'" @click.stop="edit=true">
            <v-icon class="click-effect" v-if="!workout.total_distance_done">add_circle_outline</v-icon>
            <v-icon class="click-effect" v-if="workout.total_distance_done">edit</v-icon>
          </span>
        </div>
        <ul v-if="!edit">
          <li v-if="workout.runner_time">
            <TextField label="Tempo/Czas">
              <i slot="prepend" v-tooltip="'Tempo/Czas'" class="fi flaticon-minutes "></i>
              {{workout.runner_time}}
            </TextField>
          </li>
          <li v-if="workout.runner_pulse">
            <TextField label="Tętno">
              <i slot="prepend" v-tooltip="'Tętno'" class="fi flaticon-pulse-line "></i>
              {{workout.runner_pulse}} bpm
            </TextField>
          </li>
          <li v-if="workout.total_distance_done">
            <TextField label="Pokonany dystans">
              <i slot="prepend" v-tooltip="'Pokonany dystans'" class="fi flaticon-road-1 "></i>
              {{workout.total_distance_done}} km
            </TextField>
          </li>
          <li v-if="workout.runner_additional_info">
              <TextField label="Informacje od zawodnika" pre>
                <v-icon slot="prepend" v-tooltip="'Informacje od zawodnika'">info</v-icon>{{workout.runner_additional_info}}
              </TextField>
          </li>
        </ul>
        <v-form v-if="edit && (isActiveRunnerTrainer || isActiveRunner)" @submit.prevent="saveWorkout" novalidate>
          <v-text-field
              v-model="workoutForm.total_distance_done"
              label="Pokonany dystans"
              :error="hasErrors('total_distance_done')"
              :error-messages="getErrors('total_distance_done')"
          >
            <i slot="prepend" v-tooltip="'Pokonany dystans'" class="fi flaticon-road-1"></i>
          </v-text-field>
          <v-text-field
              v-model="workoutForm.runner_pulse"
              label="Tętno"
              :error="hasErrors('runner_pulse')"
              :error-messages="getErrors('runner_pulse')"
          >
            <i slot="prepend" v-tooltip="'Tętno'" class="fi flaticon-pulse-line"></i>
          </v-text-field>
          <v-text-field
              v-model="workoutForm.runner_time"
              label="Tempo/Czas"
              :error="hasErrors('runner_time')"
              :error-messages="getErrors('runner_time')"
          >
            <i slot="prepend" v-tooltip="'Czas'" class="fi flaticon-minutes"></i>
          </v-text-field>
          <v-textarea
              v-model="workoutForm.runner_additional_info"
              label="Informacje dodatkowe"
              :error="hasErrors('runner_additional_info')"
              :error-messages="getErrors('runner_additional_info')"
              auto-grow
              box
          >
            <v-icon slot="prepend" v-tooltip="'Informacje dodatkowe'">info</v-icon>
          </v-textarea>
          <div class="save-button-container">
            <v-btn small class="very-small" color="primary" type="submit">
              zapisz
              <v-icon right small >save</v-icon>
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <div class="event-footer">
      <span v-tooltip="'Suma kilometrów'"><v-icon>mdi-sigma</v-icon>{{workout.total_distance_done || (workout.workout_done === false ? 0 : workout.total_distance_planned)}} km</span>
      <span>
        <v-icon class="click-effect" v-if="(isActiveRunner || isActiveRunnerTrainer) && workout.workout_done !== true" v-tooltip="'Trening wykonany'" @click.stop="$emit('done-workout')">done</v-icon>
        <v-icon class="click-effect" v-if="(isActiveRunner || isActiveRunnerTrainer) && workout.workout_done !== false" v-tooltip="'Trening niewykonany'" @click.stop="$emit('undone-workout')">clear</v-icon>
      </span>
    </div>
  </div>
</template>

<script>
import {doneWorkout} from './api'
import { mapGetters } from 'vuex'
import iziToast from 'izitoast'
import TextField from '@/utils/TextField'

export default {
  components: {TextField},
  props: {
    workout: {
      type: Object,
      required: true
    },
    inplace: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      workoutForm: {
        id: this.workout.id,
        runner_additional_info: this.workout.runner_additional_info || undefined,
        runner_pulse: this.workout.runner_pulse || undefined,
        runner_time: this.workout.runner_time || undefined,
        total_distance_done: this.workout.total_distance_done || this.workout.total_distance_planned || undefined
      },
      errors: {},
      edit: false
    }
  },
  computed: {
    ...mapGetters(['runner', 'isActiveRunnerTrainer', 'isActiveRunner'])
  },
  methods: {
    saveWorkout () {
      let promise = doneWorkout(this.runner, this.workoutForm).then((data) => {
        this.$emit('ended-workout', data, this.workout)
        this.edit = false
        iziToast.show({
          message: 'Trening został zmieniony',
          color: 'green'
        })
        return data
      })
      promise.catch((data) => {
        if (data.response.status === 400) {
          this.errors = data.response.data
        }
      })
    },
    getErrors (name) {
      return this.errors[name] || []
    },
    hasErrors (name) {
      return this.errors[name] !== undefined && this.errors[name].length > 0
    },
    resetErrors () {
      this.errors = {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plan/WorkoutBig.vue